export const FETCH_AUTHORIZATION_TOKEN_BEGIN="FETCH_AUTHORIZATION_TOKEN_BEGIN";
export const FETCH_AUTHORIZATION_TOKEN_SUCCESS="FETCH_AUTHORIZATION_TOKEN_SUCCESS";
export const FETCH_AUTHORIZATION_TOKEN_FAILURE="FETCH_AUTHORIZATION_TOKEN_FAILURE";
